<template>
  <b-card>
    <footer-link-form @onSubmit="handleSubmit" :footer-links="footerLinks" :is-editing="false" />
  </b-card>
</template>

<script>
import FooterLinkForm from '@/components/footer-management/FooterLinkForm';
import NotificationMixin from '@/mixins/NotificationMixin';
import { all, store } from '@/http/footer-management';

export default {
  mixins: [NotificationMixin],

  components: {
    FooterLinkForm,
  },

  data() {
    return {
      footerLinks: [],
    };
  },

  async created() {
    await this.fetchFooterLinks();
  },

  methods: {
    async fetchFooterLinks() {
      try {
        const { data } = await all();
        this.footerLinks = data.data;
      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił problem z pobraniem linków stopki. Skontaktuj się ze swoim developerem.',
        );
      }
    },

    async handleSubmit(formData) {
      try {
        await store(formData);
        this.showSuccessNotification('Dane zostały zapisane', 'Link stopki został dodany.');
        this.$router.push({ name: 'footer-management-index' });
      } catch (error) {
        const message =
          error.response?.data?.message ??
          'Wystąpił problem z dodaniem linku stopki. Skontaktuj się ze swoim developerem.';
        this.showErrorNotification('Problem z zapisaniem danych', message);
      }
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
